var exports = {
  "t": "borderGrid__VCnF9i",
};

module.exports = exports;
